import React from "react";

const Select = ({
  name,
  label,
  options,
  error,
  optValue,
  optName,
  req,
  ...rest
}) => {
  return (
    <div className={`form-group ${req && "required"}`}>
      <label className="form-control-label" htmlFor={name}>
        {label}
      </label>
      <select className="form-control" id={name} name={name} {...rest}>
        <option value="">Select</option>
        {options && options.map((option) => (
          <option key={option[optValue]} value={option[optValue]}>
            {option[optName]}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Select;
